import React, {Component } from 'react';
import {Row, Col} from 'react-bootstrap';
import { Form, Input,  Checkbox , Modal } from 'antd';
import {  } from '@ant-design/icons';
import './../../login.css';
import mHelper from './../config/Helper';
import mLoginController from './../control/Login/index.controllers';
import { Link } from 'react-router-dom';

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 24 },
};

var thisComponent;
var thisCanvas = null;
class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            captca : ""
        }
        thisComponent = this;
    }   

    onGetGenerate = (code) => {
        mLoginController.LOGIN_GET_CAPTCA_EXECUTE(code,(r)=>{
            var codeCaptca = mHelper.onDecriptCaptca(r.captca);
            this.setState({captca : codeCaptca});
            this.updateCanvas();
        });
    }

    updateCanvas = () =>{
        const ctx = thisCanvas.getContext('2d');
        ctx.clearRect(0, 0, thisCanvas.width, thisCanvas.height);
        ctx.font = "30px Georgia";
        ctx.textAlign = "start";
        ctx.strokeText(this.state.captca,50, 50);
    }

    handleCanvas =  (canvas) => {
        thisCanvas = canvas;
    }

    onReloadChaptca = () => {
        var code = mHelper.GET_COOKIES("captcha_login");
        if(code === false){
            mHelper.SET_COOKIES('captcha_login',mHelper.ON_RAND_CODE(5));
            code = mHelper.GET_COOKIES("captcha_login"); 
            this.onGetGenerate(code);
        }else{
            this.onGetGenerate(code);
        }
    }

    async componentDidMount() {
        this.onReloadChaptca();
    }

    onFinish = values => {
        console.log('Success:', values);
        var code = mHelper.GET_COOKIES("captcha_login");
        mLoginController.LOGIN_EXECUTE(values.email,values.password,code,values.captcha,(r)=>{
            if(r.error !== undefined){
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>Email or password not valid !</p>
                      </div>
                    ),
                    onOk() {
                        thisComponent.onReloadChaptca();
                    },
                });
                return;
            }
            if(r.success === false || r.success === undefined){
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>{r.message}</p>
                      </div>
                    ),
                    onOk() {
                        thisComponent.onReloadChaptca();
                    },
                });
                return;
            }
            var infoLogin = r.data
            mHelper.SET_COOKIES('login_portal',infoLogin);
            document.location.href=`${process.env.PUBLIC_URL}/dashboard`;
        });
    };
    
    onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    render() {
        return (
            <div>
                <div className="login-content">
                    <div className="login-main">
                        <Row className="margin-nol ">
                            <Col sm={12} lg={2} ></Col>
                            <Col sm={12} lg={8} >
                                <Row className="padding-top-50">
                                    <Col sm={12} className="align-items-center justify-content-center " lg={7}>
                                     </Col>
                                    <Col sm={12} lg={5}>
                                        <div className="login-form text-center rounded">
                                            <div className="contact-top">
                                                <h5 className="text-secondary fw-3 py-3">
                                                    Selamat data di digipos  tools apllication powered by Link Aja.
                                                </h5>
                                            </div>
                                            <Form
                                                {...layout}
                                                name="basic"
                                                initialValues={{ remember: true }}
                                                onFinish={this.onFinish}
                                                onFinishFailed={this.onFinishFailed}
                                            >
                                                <Form.Item
                                                    label=""
                                                    name="email"
                                                    rules={[{ type:"email" ,  required: true, message: 'Please input your email!' }]}
                                                >
                                                    <Input  placeholder="Email" className="text-login"/>
                                                </Form.Item>

                                                <Form.Item
                                                    label=""
                                                    name="password"
                                                    rules={[{ required: true, message: 'Please input your password!' },
                                                    { min: 8, message: 'Password must be minimum 8 characters.' }]}
                                                >
                                                    <Input.Password  placeholder="Password" className="text-login"/>
                                                </Form.Item>
                                                
                                                <div style={{textAlign:"center"}}>
                                                    <canvas ref={(canvas)=>this.handleCanvas(canvas)}  height={80} />
                                                </div>
                                                <Form.Item
                                                    label=""
                                                    name="captcha"
                                                    rules={[{ required: true},
                                                    { min: 5, max:5}]}>
                                                    <Input  placeholder="Captcha" className="text-login"/>
                                                </Form.Item>

                                                <Form.Item name="remember" valuePropName="checked">
                                                    <Checkbox>Remember me</Checkbox>
                                                </Form.Item>
                                                <button className="btn btn-bordered w-100  btn-login" type="submit">Sign In</button>
                                            </Form>
                                            <div>
                                           
                                            </div>
                                            <div>
                                            <span className="d-inline-block mt-3">Forgot Password ? <Link to={`${process.env.PUBLIC_URL}/reqforgotpass`}>Tekan Disini !</Link></span>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm={12} lg={2} ></Col>
                        </Row>
                    </div>
                    <div className="shape-bottom">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"><path className="shape-fill" fill="#FFFFFF" d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7  c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4  c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"></path></svg>
                    </div>
                </div>
                <div>
                    <Row className="margin-nol ">
                        <Col sm={12} lg={2} ></Col>
                        <Col sm={12} lg={8} >
                            <span className="d-inline-block fw-5 px-4 py-2 mb-3">
                                <span className="text-primary">2020 &copy; Link Aja  </span> 
                            </span>
                        </Col>
                        <Col sm={12} lg={2} ></Col>
                    </Row>
                </div>
            </div>
        )
    }

}

export default Login;
